// Maneja la instalación de la PWA. Ver CLAUDE.md §11.
// Android (Chrome/Edge): captura beforeinstallprompt y lo dispara al tocar el botón.
// iOS (Safari): no hay evento; se muestran instrucciones manuales.
import { useEffect, useState } from 'react'

interface BeforeInstallPromptEvent extends Event {
  prompt: () => Promise<void>
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>
}

export function useInstallPrompt() {
  const [deferred, setDeferred] = useState<BeforeInstallPromptEvent | null>(null)
  const [installed, setInstalled] = useState(false)

  useEffect(() => {
    const onBeforeInstall = (e: Event) => {
      e.preventDefault()
      setDeferred(e as BeforeInstallPromptEvent)
    }
    const onInstalled = () => {
      setInstalled(true)
      setDeferred(null)
    }
    window.addEventListener('beforeinstallprompt', onBeforeInstall)
    window.addEventListener('appinstalled', onInstalled)
    return () => {
      window.removeEventListener('beforeinstallprompt', onBeforeInstall)
      window.removeEventListener('appinstalled', onInstalled)
    }
  }, [])

  const nav = navigator as Navigator & { standalone?: boolean }
  const isStandalone =
    window.matchMedia('(display-mode: standalone)').matches || nav.standalone === true
  const isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent)

  const promptInstall = async () => {
    if (!deferred) return
    await deferred.prompt()
    setDeferred(null)
  }

  return { canInstall: deferred !== null, isIOS, isStandalone, installed, promptInstall }
}
